module.exports = __webpack_public_path__ + "img/facebook.9720a15e.svg";